import router from '@/router'
import defaultAvatar from '@/assets/images/location/location.svg'
import i18n from '@/libs/i18n'
import store from '@/store'
import MapPinRed from '@/assets/images/location/map-marker-icon-red.png'
import MapPinBlue from '@/assets/images/location/map-marker-icon-blue.png'
import MapPinOrange from '@/assets/images/location/map-marker-icon-orange.png'
import MapPinApprox from '@/assets/images/location/map-marker-icon-approx.png'
import MarkerShadow from 'leaflet/dist/images/marker-shadow.png'

import {
  icon, Icon,
} from 'leaflet'

export const useLocationOptions = () => {
  const initLocationData = {
    id: '',
    user_id: '',
    lng: '',
    lat: '',
    exact: true,
    address: {
      country: '',
      country_code: '',
      postcode: '',
      municipality: '',
      county: '',
      state: '',
      locality: '',
      locality_type: '',
      state_district: '',
      suburb: '',
      district: '',
      quarter: '',
      borough: '',
      city_district: '',
      neighbourhood: '',
      man_made: '',
      road: '',
      house_number: '',
      building: '',
      apartment_number: '',
      address_confirmed: false,
      address_comment: '',
    },
    formatted_address: '',
    position: {
      lat: null,
      lng: null,
    },
    radius: 50000,
    viewport: {
      _southWest: {
        lat: 0,
        lng: 0,
      },
      _northEast: {
        lat: 0,
        lng: 0,
      },
    },
    viewportRadius: 0,
    viewportPosition: {
      lat: null,
      lng: null,
    },
    viewportBounds: {},

  }

  const getMarker = style => {
    switch (style) {
      case 'red':
        return MapPinRed
      case 'orange':
        return MapPinOrange
      case 'approx':
        return MapPinApprox

      default:
        return MapPinBlue
    }
  }
  const getMarkerIconOptions = style => {
    const iconUrl = getMarker(style)
    return style !== 'approx' ? {
      iconRetinaUrl: iconUrl,
      iconUrl,
      shadowUrl: MarkerShadow,
      iconSize: [40, 60],
      iconAnchor: [20, 58],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [64, 64],
    } : {
      iconRetinaUrl: iconUrl,
      iconUrl,
      shadowUrl: MarkerShadow,
      iconSize: [128, 128],
      iconAnchor: [62, 62],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [0, 0],
    }
  }

  const getMarkerIcon = style => icon(getMarkerIconOptions(style))
  return {
    initLocationData,
    getMarkerIconOptions,
    getMarkerIcon,
  }
}

export const useLocationUi = () => {
  const getLocationRequestRoute = location => ({
    name: 'apps-service-request-add-wizard',
    query: { locationId: location.public_alias, locale: i18n.locale },
  })
  const getLocationRequestLink = location => {
    const props = router.resolve(getLocationRequestRoute(location))
    return props ? window.location.origin + props.href : ''
  }

  const locationEdit = location => {
    router.push({ name: 'apps-location-edit', params: { id: location.id } })
  }
  const locationAddRequest = location => {
    // window.open(getLocationRequestLink(location))
    router.push(getLocationRequestRoute(location))
  }

  const getAvatar = location => location.avatar || defaultAvatar

  const locationInfo = location => {
    router.push({ name: 'apps-location-info', params: { id: location.id } })
  }

  return {
    locationInfo,
    locationEdit,
    locationAddRequest,
    getAvatar,
    getLocationRequestLink,
  }
}
export const useLocationRemoteData = () => {
  const getLocalityType = location => {
    if ('city' in location.address) {
      return 'city'
    }
    if ('town' in location.address) {
      return 'town'
    }
    if ('village' in location.address) {
      return 'village'
    }
    return ''
  }
  const getLocationPayload = () => {
    const { initLocationData } = useLocationOptions()
    const location = store.getters['location/location']
    const locationAddress = JSON.parse(JSON.stringify({ ...initLocationData.address, ...location.address }))
    const data = { lat: location.lat, lng: location.lng }
    const address = {
      country: locationAddress.country,
      country_code: locationAddress.country_code,
      postcode: locationAddress.postcode,
      municipality: locationAddress.municipality,
      county: locationAddress.county,
      state: locationAddress.state,
      province: locationAddress.province,
      locality: locationAddress.locality,
      locality_type: getLocalityType(location),
      state_district: locationAddress.state_district,
      suburb: locationAddress.suburb,
      district: locationAddress.district,
      quarter: locationAddress.quarter,
      borough: locationAddress.borough,
      city_district: locationAddress.city_district,
      neighbourhood: locationAddress.neighbourhood,
      man_made: locationAddress.man_made,
      road: locationAddress.road,
      house_number: locationAddress.house_number,
      building: locationAddress.building,
      apartment_number: locationAddress.apartment_number,
      address_comment: locationAddress.address_comment,
      address_confirmed: location.address_confirmed,
    }
    return { data, address }
  }

  const addLocationLookup = () => store.dispatch('location/addLocationLookup', getLocationPayload())

  const transformFetchedLocality = location => {
    if ('city' in location.address) {
      return location.address.city
    }
    if ('town' in location.address) {
      return location.address.town
    }
    if ('village' in location.address) {
      return location.address.village
    }
    return ''
  }

  return {
    addLocationLookup,
    getLocationPayload,
    transformFetchedLocality,
  }
}
